(function () {
	const initSlider = () => {
		let productSlider;
		const productSliders = document.querySelectorAll('.products-onsale-slider');

		productSliders.forEach((slider, index) => {
			productSlider = new Swiper(slider, {
				slidesPerView: slider.dataset.mobile,
				spaceBetween: 12,
				loop: false,
				navigation: {
					nextEl: ".onsale-slider-next",
					prevEl: ".onsale-slider-prev",
				},
				breakpoints: {
					1080: {
						slidesPerView: slider.dataset.desktop
					},
					850: {
						slidesPerView: 6
					},
					700: {
						slidesPerView: 4
					},
					576: {
						slidesPerView: 2
					}
				}
			});
		});
	};

	const destroySlider = () => {
		const productSliders = document.querySelectorAll('.products-onsale-slider');

		productSliders.forEach((slider, index) => {
			if (slider.swiper !== undefined) slider.swiper.destroy();
		});
	};

	const initSection = () => {
		const sections = document.querySelectorAll('.products-slider-section');

		const sectionResizeObserver = new ResizeObserver((entries) => {
			destroySlider();
			initSlider();
		});

		destroySlider();
		initSlider();

		sections.forEach(item => {
			sectionResizeObserver.observe(item);
		});
	};

	initSection();

	document.addEventListener('shopify:section:load', function () {
		initSection();
	});
})();